import { Injectable} from '@angular/core';
import { Headers, RequestOptions, Http } from '@angular/http';
import * as config from '../app.config.json';

@Injectable()
export class ConfigService {

    data;

        constructor() { 
            this.data = config;
        }

        // get(): Promise<any> {
        //     this.data = config;
        //     return Promise.resolve(config);
        // }
    
        // constructor(private http: Http) { 
        //     this.http.get('/api/config').subscribe(response => {
        //         this.data = response.json();
        //     })
        // }
    
        // get(): Promise<any> {
        //     return this.http.get('/api/config')
        //         .toPromise()
        //         .then(response => {
        //             this.data = response.json();
        //             return this.data;
        //         })
        // }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/config.service.ts